import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { WorkspacesFeature } from './selectors';
import {
  AnalyzeClauseVarianceResponseDto,
  WorkspaceDetailsDto,
  WorkspaceDocumentDto,
  WorkspaceDto,
  WorkspaceUpdateModel,
} from '../models/workspaces.model';
import { WorkspaceCreateMetadata } from '../services/workspaces-api.service';
import { DocumentProcessingPagedReviewResponse } from '../../documents/services/document-processing-api.service';

export const WorkspacesActions = createActionGroup({
  source: WorkspacesFeature,
  events: {
    'Get Workspaces': emptyProps(),
    'Load Workspaces Fail': emptyProps(),
    'Load Workspaces': emptyProps(),
    'Set Workspaces': props<{ workspaces: WorkspaceDto[] }>(),
    'Create Workspace': props<{
      name: string;
      metadata: Record<string, WorkspaceCreateMetadata>;
      filesById: Record<string, File>;
    }>(),
    'Create Workspace Success': props<{ workspace: WorkspaceDto }>(),
    'Create Workspace Fail': emptyProps(),
    'Create Workspace Cancel': props<{ pristine: boolean }>(),
    'Create Workspace Cancelled': emptyProps(),
    'Clear Create Workspace Cancelled': emptyProps(),
    'Close Creating Workspace Modal': emptyProps(),
    // 'Set Edited Workspace': props<{ workspace: WorkspaceDto }>(),
    'Add Workspace Documents': props<{ model: WorkspaceUpdateModel }>(),
    'Add Workspace Documents Success': props<{ workspace: WorkspaceDto }>(),
    'Add Workspace Documents Fail': emptyProps(),
    'Add Workspace Documents Cancel': props<{ pristine: boolean }>(),
    'Add Workspace Documents Cancelled': emptyProps(),
    'Clear Add Workspace Documents Cancelled': emptyProps(),
    'Close Add Workspace Documents Modal': emptyProps(),
    'Delete Workspace': props<{ id: string }>(),
    'Delete Workspace Confirmed': props<{ id: string; keepDocuments: boolean }>(),
    'Delete Workspace Success': emptyProps(),
    'Delete Workspace Fail': emptyProps(),
    'Delete Workspace Cancel': emptyProps(),
    'Get Workspace Details': props<{ id: string }>(),
    'Set Workspace Details': props<{ workspaceDetails: WorkspaceDetailsDto }>(),
    'Set Reference Document': props<{ referenceDocument: WorkspaceDocumentDto | null }>(),
    'Rename Workspace': props<{ name: string; id: string }>(),
    'Rename Workspace Success': props<{ workspace: WorkspaceDto }>(),
    'Rename Workspace Fail': emptyProps(),
    'Rename Workspace Cancel': props<{ pristine: boolean }>(),
    'Rename Workspace Cancelled': emptyProps(),
    'Clear Rename Workspace Cancelled': emptyProps(),
    'Close Renaming Workspace Modal': emptyProps(),
  },
});

export const ClauseVarianceAnalysisActions = createActionGroup({
  source: WorkspacesFeature,
  events: {
    'Analyze Clause Variance': props<{ workspaceId: string; referenceDocumentId: string }>(),
    'Analyze Clause Variance Success': props<{ response: AnalyzeClauseVarianceResponseDto }>(),
    'Analyze Clause Variance Fail': emptyProps(),
  },
});

export const GetReviewActions = createActionGroup({
  source: WorkspacesFeature,
  events: {
    'Initialize Review Data For Documents': props<{ documentIds: string[] }>(),
    'Get Paged Review Data': props<{
      documentId: string;
      playbookId: string;
    }>(),
    'Get Paged Review Data Success': props<{
      pagedReviewData: DocumentProcessingPagedReviewResponse;
    }>(),
    'Get Paged Review Data Failure': props<{ documentId: string }>(),
    'Get Paged Review Data Complete': props<{ documentId: string }>(),
    'Set Document Review Done With Errors': props<{ value: boolean }>(),
    'Set Page Number Of Review Data': props<{ documentId: string; pageNumber: number }>(),
  },
});
